/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('TicketCountCtrl', function($scope, Ticket) {
    const getUnreadTickets = () => $scope.unread = Ticket.getUnread();

    getUnreadTickets();
    setInterval(getUnreadTickets, 30000);
});
